<template>
  <main>
    <ticker-admin-nav />
    <h4>Universal Security Master</h4>
    <h5>Services</h5>
    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Level</th>
          <th>Product</th>
          <th>Country</th>
          <th>Benchmark</th>
          <th>Portfolios</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="service in services" :key="service.id">
          <td>{{ service.id }}</td>
          <td>
            {{ service.name }}
            <router-link :to="`/tickeradmin/editservice?service_id=${service.id}`"
                         v-show="$auth.hasRoles('admin', 'recs-admin')"
            >
              <i class="far fa-edit clickable amber-text big" />
            </router-link>
          </td>
          <td>{{ service.level }}</td>
          <td>{{ service.product_id ? '#' : '' }}{{ service.product_id }}</td>
          <td>
            <span v-if="service.country">
              <img :src="`https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.1.0/flags/4x3/${service.country.code.toLowerCase()}.svg`"
                    height="10"
              >
              {{ service.country.name }}
            </span>
          </td>
          <td>{{ service.benchmark.name.slice(0, 14) }}</td>
          <td>
            <p v-for="portfolio in service.portfolios"
               :key="portfolio.id"
               class="portfolio-link-wrapper"
            >
              <router-link :to="`/tickeradmin/viewportfolio?portfolio_id=${portfolio.id}`" class="portfolio-link">
                <span class="new badge grey lighten-3 grey-text"
                      data-badge-caption=""
                      v-if="!portfolio.active"
                >
                  Inactive
                </span>
                {{ portfolio.name }}
              </router-link>
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <aside class="usm-add-service-aside" v-show="$auth.hasRoles('admin', 'recs-admin')">
      <router-link to="/tickeradmin/addservice">
        <button id="usm-add-service-btn"
                class="btn-large btn-floating waves-effect waves-light teal accent-4"
        >
          <i class="fas fa-plus" />
        </button>
        <label for="usm-add-service-btn">Add Service</label>
      </router-link>
    </aside>
  </main>
</template>

<script>
import axios from 'axios';
import TickerAdminNav from '@/components/TickerAdminNav.vue';

export default {
  name: 'TickerAdminListServices',
  components: { TickerAdminNav },
  props: {},
  data() {
    return {
      services: [],
    };
  },
  computed: {},
  watch: {},
  methods: {
    async fetchMetadata() {
      const promises = [
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/services/`),
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/portfolios/`),
      ];
      const [servicesResp, portfoliosResp] = await Promise.all(promises);
      const services = servicesResp.data;
      const portfolios = portfoliosResp.data;
      services.forEach(service => {
        service.portfolios = portfolios.filter(portfolio => portfolio.service === service.id);
      });
      // Sort by ID, then push Options Service (id=188) to bottom of list
      this.sortArray(services, 'id');
      services.push(services.splice(services.map(service => service.id).indexOf(188), 1)[0]);
      this.services = services;
    },
  },
  mounted() {
    this.fetchMetadata();
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

.portfolio-link-wrapper {
  margin: 0px;
  & > .portfolio-link {
    transition: color 0.25s;
    &:hover {
      color: #ffab00;
    }
  }
}

.usm-add-service-aside {
  position: absolute;
  top: 100px;
  right: 30px;
  & label {
    display: block;
    margin-top: 8px;
  }
}
</style>
